import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=7ff56966&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionPostHero: require('/codebuild/output/src1513447352/src/lusio/components/section/PostHero.vue').default,PostContentSections: require('/codebuild/output/src1513447352/src/lusio/components/PostContentSections.vue').default,CTA: require('/codebuild/output/src1513447352/src/lusio/components/CTA.vue').default,Footer: require('/codebuild/output/src1513447352/src/lusio/components/global/Footer.vue').default,SEO: require('/codebuild/output/src1513447352/src/lusio/components/global/SEO.vue').default,SmoothScroll: require('/codebuild/output/src1513447352/src/lusio/components/global/SmoothScroll.vue').default,PreviewModeWrapper: require('/codebuild/output/src1513447352/src/lusio/components/global/PreviewModeWrapper.vue').default})
